// Cross-section action-items API. Cross-cutting concern — lives in core/ so
// the Inbox view and every section can read/close without breaching
// section-isolation rules.
import { api } from "./client";
import type { ActionItem } from "./types";

export async function listActionItems(opts: {
  status?: "open" | "closed";
  reportId?: string;
}): Promise<ActionItem[]> {
  const params = new URLSearchParams();
  if (opts.status) params.set("status", opts.status);
  if (opts.reportId) params.set("report_id", opts.reportId);
  const qs = params.toString();
  const data = await api.get<{ items: ActionItem[] }>(`/action-items${qs ? `?${qs}` : ""}`);
  return data.items;
}

export async function closeActionItem(id: string): Promise<void> {
  await api.post<{ status: string }>(`/action-items/${id}/close`);
}

export async function getActionItem(id: string): Promise<ActionItem> {
  const data = await api.get<{ action_item: ActionItem }>(`/action-items/${id}`);
  return data.action_item;
}
